<template>
  <div>
    <h3 class="text-center __title2">
      Choose Container Size &#38; Quantity
    </h3>
    <div class="row m-0 justify-content-center">
      <button
        class=" __block __blocksize"
        type="button"
        name="button"
        v-bind:class="{ active: isC20ft }"
        @click="chooseContainer('ft20')"
      >
        <img class="__img1" src = "@/assets/image/instantprice/container.svg" />
        <p class="__title">20 FT Container</p>
      </button>
      <button
        class="__block __blocksize"
        type="button"
        name="button"
        v-bind:class="{ active: isC40ft }"
        @click="chooseContainer('ft40')"
      >
        <img class="__img2" src = "@/assets/image/instantprice/container.svg" />
        <p class="__title">40 FT Container</p>
      </button>
      <button
        class="__block __blocksize"
        type="button"
        name="button"
        v-bind:class="{ active: isC40fthc }"
        @click="chooseContainer('ft40hc')"
      >
        <img class="__img3" src = "@/assets/image/instantprice/container.svg" />
        <p class="__title">40 FT High Cube</p>
      </button>
    </div>
    <div v-for="(item, index) in form.loadsFCL" :key="index" class="col-md p-0 mb-4">
      <div class="row justify-content-center __inputfield2">
        <div style="width: 280px; margin-right: 22px">
          <p>Container Option</p>
          <div class="options__defaultdropdown">
            <b-input-group>
              <b-dropdown right class="col-md p-0">
                <template slot="button-content">
                  <p class="m-0" :class="form.container_option ? 'item__selected' : ''">{{containerValue}}</p>
                </template>
                <b-dropdown-item
                  v-for="option in containerOptions" :key="option.id" @click="containerSelected(option)">
                  <span>{{ option.text }}</span>
                </b-dropdown-item>
              </b-dropdown>
              <img class="options__defaultdropdown--imgabsolute"
                src = "@/assets/image/image/gray-down-arrow@3x.png">
            </b-input-group>
          </div>
          <div v-if="error.container_option && showError" class="text-left">
            <small class="text-danger">Required</small>
          </div>
        </div>
        <div class=" __weight">
          <p>Weight Estimation</p>
          <b-input-group class="__inputgroup2" append="KG">
            <b-form-input type="number" @input="calcTotalShipment()"
             v-model="form.weight_estimation"
            />
          </b-input-group>
          <div  v-if="error.weight_estimation && showError" class="text-left">
            <small class="text-danger">Required</small>
          </div>
        </div>
      </div>
      <div class="row justify-content-center __inputfield2">
        <div class="__customdropdown2 ml-3 mr-3">
          <p>Container Type</p>
          <b-input-group>
            <b-dropdown right :disabled="index > 0">
              <template slot="button-content">
               <p class="m-0">{{ item.type }}</p>
              </template>
              <b-dropdown-item
                @click="setType('Dry')
                ifReefer=false">
                <span>Dry</span>
              </b-dropdown-item>
              <b-dropdown-item
                @click="setType('Ventilate'), ifReefer=false">
                <span>Ventilate</span>
              </b-dropdown-item>
              <b-dropdown-item
                @click="setType('Reefer'), ifReefer=true">
                <span>Reefer</span>
              </b-dropdown-item>
            </b-dropdown>
            <img class="__imgArrow" src = "@/assets/image/instantprice/right-arrow.svg">
          </b-input-group>
        </div>
        <div class="__celcius ml-3 mr-3" v-if="ifReefer">
          <b-input-group class="__input" >
            <b-form-input
              v-model="item.temperature"
              type="number"
              placeholder=""
            />
          </b-input-group>
        </div>
        <div class="__celcius ml-4 mr-3" v-if="ifReefer">
          <p>&#8451;</p>
        </div>
        <div class="__qty ml-3 mr-3">
          <p>Quantity</p>
          <b-input-group class="__input">
            <b-form-input
              v-model="item.qty"
              type="number"
              placeholder=""
              @keyup="calcTotalShipment()"
              />
          </b-input-group>
          <div v-if="error.qty && showError" class="text-left">
            <small class="text-danger">Required</small>
          </div>
        </div>
        <!-- <div
          v-if="index === 0"
          class="__btnplus"
          @click="addContainer()"
        >
            <img src="@/assets/image/instantprice/Group 2626.png" alt="">
        </div>
        <div
          v-else
          class="__btnremove"
          @click="removeContainer(index)"
        >
          <img src="@/assets/image/instantprice/buttonX.png" alt="" />
        </div> -->
      </div>  <!-- end __inputfield -->
    </div>
    <div class="row m-0 _total__box_">
      <p class="col-md">Total Shipment:</p>
      <p class="col-md">{{ totalUnit }} Unit</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'fcl',
  props: {
    showError: Boolean
  },
  data () {
    return {
    // weight 20 => standard
    // 40 => overweight
      ifReefer: false,
      isC20ft: false,
      isC40ft: false,
      isC40fthc: false,
      Refeer: false,
      type: 'Ocean',
      totalUnit: 0,
      inputLoadsFCL: {
        id: 0,
        temperature: '',
        size: 'ft20',
        qty: '',
        type: 'Dry',
        weight: '0'
      },
      form: {
        typeObj: 'sub',
        loadsFCL: [],
        service_head: 'OCEAN',
        shipment_type: 'SEAFCL20FT',
        shipmentType: 'SEAFCL20FT',
        totalUnit: 1,
        freight_sub_type: 'Dry',
        container_option: '',
        weight_estimation: ''
      },
      errorData: {
        errorsFCL: false
      },
      error: {
        qty: false,
        container_option: false,
        weight_estimation: false
      },
      containerOptions: [
        { id: 1, text: "Shipper's Own Container (SOC)", value: 'SOC' },
        { id: 2, text: "Carrier's Owned Container (COC)", value: 'COC' }
      ],
      containerValue: 'Choose your container option'
    }
  },
  methods: {
    init () {
      this.form.loadsFCL.push({...this.inputLoadsFCL})
    },
    containerSelected (item) {
      this.containerValue = item.text
      this.form.container_option = item.value
      this.pushData()
      this.checkError()
    },
    chooseContainer (type) {
      this.isC40fthc = type === 'ft40hc'
      this.isC40ft = type === 'ft40'
      this.isC20ft = type === 'ft20'

      if (type === 'ft40hc') {
        this.form.shipmentType = 'SEAFCL40FTHC'
      } else if (type === 'ft40') {
        this.form.shipmentType = 'SEAFCL40FT'
      } else if (type === 'ft20') {
        this.form.shipmentType = 'SEAFCL20FT'
      }

      this.form.loadsFCL.reduce((total, obj) => { obj.size = type }, {})

      // this.inputLoadsFCL.size = type
      this.pushData()
    },
    addContainer () {
      let arr = this.form.loadsFCL
      let i = arr.length + 1

      this.inputLoadsFCL.id = i
      this.inputLoadsFCL.weight = this.inputLoadsFCL.size !== 'ft20' ? 'overweight' : 'standard'

      arr.push({...this.inputLoadsFCL})
      this.calcTotalShipment()
      this.pushData()
    },
    removeContainer (index) {
      let arr = this.form.loadsFCL

      this.$delete(arr, index)
      this.calcTotalShipment()
      this.pushData()
    },
    pushData () {
      this.$emit('IntantPriceData', this.form)
    },
    calcTotalShipment () {
      let arr = this.form.loadsFCL
      this.totalUnit = arr.reduce((total, obj) => parseInt(obj.qty ? obj.qty : 0) + parseInt(total), 0)
      this.form.totalUnit = this.totalUnit
      this.pushData()
      this.checkError()
    },
    setType (type) {
      let arr = this.form.loadsFCL
      arr.reduce((total, obj) => { obj.type = type }, {})
      this.inputLoadsFCL.type = type
      this.form.freight_sub_type = type
      this.pushData()
    },
    checkError () {
      if (!this.form.loadsFCL[0].qty || this.form.loadsFCL[0].qty < 1) {
        this.error.qty = true
      } else {
        this.error.qty = false
      }

      if (!this.form.container_option) {
        this.error.container_option = true
      } else {
        this.error.container_option = false
      }

      if (!this.form.weight_estimation || this.form.weight_estimation < 1) {
        this.error.weight_estimation = true
      } else {
        this.error.weight_estimation = false
      }

      if (!this.error.qty && !this.error.container_option && !this.error.weight_estimation) {
        this.errorData.errorsFCL = false
      } else {
        this.errorData.errorsFCL = true
      }

      // const loadsArrayFCLErrors = []
      // this.form.loadsFCL.forEach((load, loadIndex) => {
      //   const loadsErrors = { qty: null, container_option: null, weight_estimation: null }
      //   if (!load.qty || load.qty < 1) {
      //     loadsErrors.qty = true
      //     loadsArrayFCLErrors[loadIndex] = loadsErrors
      //   } else {
      //     loadsErrors.qty = null
      //     loadsArrayFCLErrors[loadIndex] = loadsErrors
      //   }

      //   if (!this.form.container_option) {
      //     loadsErrors.container_option = true
      //     loadsArrayFCLErrors[loadIndex] = loadsErrors
      //   } else {
      //     error.loadsFCL[loadIndex].container_option = null
      //     loadsArrayFCLErrors[loadIndex] = loadsErrors
      //   }

      //   if (!this.form.weight_estimation || load.weight_estimation < 1) {
      //     loadsErrors.weight_estimation = true
      //     loadsArrayFCLErrors[loadIndex] = loadsErrors
      //   } else {
      //     loadsErrors.weight_estimation = null
      //     loadsArrayFCLErrors[loadIndex] = loadsErrors
      //   }

      //   if (!loadsErrors.qty && this.form.container_option && this.form.weight_estimation) {
      //     this.errorData.errorsFCL = false
      //   } else {
      //     this.errorData.errorsFCL = true
      //   }
      //   return loadsErrors
      // })

      // if (loadsArrayFCLErrors.length) {
      //   error.loadsFCL = loadsArrayFCLErrors
      // }
      this.$emit('errorInput', this.errorData)
    }
  },
  mounted () {
    this.isC20ft = true
    this.$emit('IntantPriceShipmentType', 'FCL20FT')
    this.$emit('IntantPriceData', { shipmentLoad: 'fcl' })
    this.calcTotalShipment()
    this.pushData()
  },
  created () {
    this.pushData()
    this.init()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/instantPrice/ShipmentType/FCL.vue